import TruckingReactAPI from '../../lib/TruckingReactAPI';
import {
  handleError,
  error,
  receive,
  request
} from '../../lib/Utils';
import Swagger from 'swagger-client';

import {
  callApi
} from '../../lib/SwaggerApi';

let SwaggerApi = new Swagger('/api/docs');


export const INVITATIONS = {
  REQUEST: "INVITATIONS_REQUEST",
  SUCCESS: "INVITATIONS_SUCCESS",
  FAILURE: "INVITATIONS_FAILURE"
};

export const RESEND_INVITATIONS = {
  REQUEST: "RESEND_INVITATIONS_REQUEST",
  SUCCESS: "RESEND_INVITATIONS_SUCCESS",
  FAILURE: "RESEND_INVITATIONS_FAILURE"
};

export const DELETE_INVITATIONS = {
  REQUEST: "DELETE_INVITATIONS_REQUEST",
  SUCCESS: "DELETE_INVITATIONS_SUCCESS",
  FAILURE: "DELETE_INVITATIONS_FAILURE"
};

export const INVITATE_CLIENT = {
  REQUEST: "INVITATE_CLIENT_REQUEST",
  SUCCESS: "INVITATE_CLIENT_SUCCESS",
  FAILURE: "INVITATE_CLIENT_FAILURE"
};



export const GENERATE_INVITATION_CODE = {
  REQUEST: "GENERATE_INVITATION_CODE_REQUEST",
  SUCCESS: "GENERATE_INVITATION_CODE_SUCCESS",
  FAILURE: "GENERATE_INVITATION_CODE_FAILURE"
};

let api = new TruckingReactAPI({
  domain: '/api'
});

export function deleteInvitation(emails, callback){
  emails = Object.values(emails);
  return callApi({
    client: {
      emails
    }
  }, "Invitations", "deleteInvitation", DELETE_INVITATIONS, callback);

}

export function resendInvitation(emails, callback) {
  emails = Object.values(emails);
  return callApi({
    client: {
      emails
    }
  }, "Invitations", "resendInvitation", RESEND_INVITATIONS, callback);
}

export function inviteClient(emails, callback = () => false) {

  return (dispatch) => {
    dispatch(request(INVITATE_CLIENT));

    SwaggerApi.then(client => {
      emails = Object.values(emails);
      client.apis.Invitations.inviteClient({
        client: {
          emails
        }
      }).then(payload => {
        if (payload.ok) {
          dispatch(receive(INVITATE_CLIENT, payload.body));
          callback(null, payload.body);
        } else {
          handleError(dispatch, payload, INVITATE_CLIENT, callback);
        }
      }).catch((err) => {
        dispatch(error(INVITATE_CLIENT, {
          status: 0,
          message: err.message
        }));
        callback(err);
      });
    }).catch(err => {
      dispatch(error(INVITATE_CLIENT, {
        status: 0,
        message: err.message
      }));
      callback(err);
    });
  };
}


export function generateInvitationCode() {
  return (dispatch) => {

    dispatch(request(GENERATE_INVITATION_CODE));

    return api
      .generateInvitationCode()
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(GENERATE_INVITATION_CODE, json));
            });
        } else {
          handleError(dispatch, payload, GENERATE_INVITATION_CODE);
        }
      })
      .catch(function (err) {
        dispatch(error(GENERATE_INVITATION_CODE, {
          message: err.message
        }));
      });
  };
}

export function getInvitationCodes(parameters, callback = () => false) {

  return (dispatch) => {
    dispatch(request(INVITATIONS));

    SwaggerApi.then(client => {
      client.apis.Invitations.getInvitationCodes(parameters)
        .then(payload => {
          if (payload.ok) {
            dispatch(receive(INVITATIONS, payload.body));
            callback(null, payload.body);
          } else {
            handleError(dispatch, payload, INVITATIONS, callback);
          }
        }).catch((err) => {
          dispatch(error(INVITATIONS, {
            status: 0,
            message: err.message
          }));
          callback(err);
        });
    }).catch(err => {
      dispatch(error(INVITATIONS, {
        status: 0,
        message: err.message
      }));
      callback(err);
    });
  };
}


// WEBPACK FOOTER //
// ./src/containers/Clients/InvitationsActions.js